<template>

  <div>
    <el-container style="height:100vh; border: 1px solid #eee">
      <el-aside width="200px;height:100vh;">
        <div>
          <LabelHeader msg="角色分类"></LabelHeader>

          <div class="buttons">
            <el-button @click="expandAll" size="mini" type="primary" style="width: 40%">展开</el-button>
            <el-button @click="foldAll" size="mini" type="warning" style="width: 40%">收起</el-button>
          </div>
          <div class="left">
            <el-tree
                    :highlight-current="true"
                    :data="dataTree"
                    v-if="elTrees"
                    :default-expand-all="expandAlls"
                    ref="menu"
                    node-key="id"
                    @node-click="go"
                    :expand-on-click-node="false"
            />
          </div>
        </div>
      </el-aside>

      <el-main style="padding: 0px 5px;">
        <div>
          <LabelHeader msg="角色管理"></LabelHeader>
          <div style="padding-left: 20px;">
            <el-form class="roleSearchForm" :inline="true">
              <el-form-item label="角色名称：">
                <el-input style="width:220px;" class="roleName" size="small" type="text" v-model="nameKey" placeholder="请输入名称" />
              </el-form-item>
              <el-form-item>
                <el-switch v-model="isGlobalQuery" :small="true" size="mini" active-text="全局查询">全局查询</el-switch>
              </el-form-item>
              <el-form-item>
                <el-button class="roleSearchBtn" type="primary" size="small" icon="el-icon-search" @click="list">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <LabelHeader msg="查询结果"></LabelHeader>

          <div class="buttonBox">
            <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="roleAdd">新增 </el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeRole">删除</el-button>
          </div>
          <div class="table-box">
            <div class="table-border">
              <el-table
                      :data="datas"
                      border
                      stripe
                      style="width: 100%"
                      :height="elTableHeight"
                      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
                      :highlight-current-row="true"
                      @selection-change="handleSelectionChange"
              >
                <el-table-column :width="40" align="center" type="selection"></el-table-column>
                <el-table-column prop="name" label="角色名称" align="center" min-width="150px"></el-table-column>
                <el-table-column prop="description" label="角色描述" align="center" min-width="220px"></el-table-column>
                <el-table-column prop="orderNum" label="序号" align="center" min-width="50px"></el-table-column>
                <el-table-column label="操作" align="center" min-width="350px">
                  <template slot-scope="data">
                    <el-button type="primary" @click="roleEdit(data.row.id)" size="mini" icon="el-icon-edit">修改</el-button>
                    <el-button type="success" @click="roleAuth(true, data.row.id)" size="mini">菜单授权</el-button>
                    <el-button type="warning" @click="(moduleOpen = true), (byId = data.row.id)" size="mini">模型授权</el-button>
                    <el-button type="success" @click="(quickModule = true), (byId = data.row.id)" size="mini">快捷授权</el-button>
                    <el-button type="warning" size="mini" icon="el-icon-s-custom" @click="(boundRole = true), (byId = data.row.id)">绑定</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="roleTips">注意：新增角色，请添加对应菜单权限</div>
              <div class="paginationBox" v-if="pagination.total > 0">
                <el-pagination
                        layout="total, sizes, prev, pager, next, jumper"
                        :page-sizes="[10, 20, 50, 100]"
                        :total="pagination.total"
                        @size-change="sizeChange"
                        @current-change="currentChange"
                        :page-size="10"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <el-dialog
                  v-dialogDrag
                  :title="title"
                  v-if="OpenName"
                  :visible.sync="OpenName"
                  :close-on-click-modal="false"
                  lock-scroll
                  :modal="false"
                  width="900px"
          >
            <Edit :params="editParams" @roleAuth="roleAuth" @close="close" @succ="succ"></Edit>
          </el-dialog>
          <el-dialog
                  v-dialogDrag
                  v-if="AuthOpen"
                  title="权限列表"
                  :visible.sync="AuthOpen"
                  :close-on-click-modal="false"
                  lock-scroll
                  :modal="false"
                  width="500px"
          >
            <Auth :params="{ id: byId }" @close="close" @users="users"></Auth>
          </el-dialog>
          <el-dialog
                  v-dialogDrag
                  v-if="moduleOpen"
                  title="模型精确授权"
                  :visible.sync="moduleOpen"
                  :close-on-click-modal="false"
                  lock-scroll
                  :modal="false"
                  width="500px"
          >
            <ModuleAuth :params="{ id: byId }" @close="close" @modules="modules"></ModuleAuth>
          </el-dialog>
          <el-dialog
                  v-dialogDrag
                  v-if="quickModule"
                  title="模型快捷授权"
                  :visible.sync="quickModule"
                  :close-on-click-modal="false"
                  lock-scroll
                  :modal="false"
                  width="530px"
          >
            <quickAuth :params="{ id: byId }" @close="close" @modules="modules"></quickAuth>
          </el-dialog>
          <el-dialog
                  v-dialogDrag
                  v-if="boundRole"
                  title="授权列表"
                  :visible.sync="boundRole"
                  :close-on-click-modal="false"
                  lock-scroll
                  :modal="false"
                  width="900px"
          >
            <Bound :params="{ id: byId }" @close="close" @success="success"></Bound>
          </el-dialog>
          <el-dialog
                  v-dialogDrag
                  v-if="OpenName2"
                  title="新增角色分类"
                  :visible.sync="OpenName2"
                  :close-on-click-modal="false"
                  lock-scroll
                  :modal="false"
                  width="500px"
          >
            <roleType :params="editParams" @close="close" @success="success"></roleType>
          </el-dialog>
        </div>

      </el-main>
    </el-container>
  </div>
</template>
<script>
import Edit from './edit';
import Auth from './authorization';
import LabelHeader from "../../components/LabelHeader";
export default {
  data() {
    return {
      teamId: '',
      teamIdData: '',
      split: 0.15,
      elTrees: true,
      expandAlls: false,
      arr: [],
      datas: [],
      title: '新增角色',
      dataTree: [],
      param: {
        keyName: 'id',
        parentName: 'pid',
        titleName: 'name',
        dataMode: 'tree',
        datas: ''
      },
      editParams: {
        id: ''
      },
      AuthOpen: false,
      OpenName2: false,
      moduleOpen: false,
      quickModule: false,
      OpenName: false,
      boundRole: false,
      byId: null,
      codeKey: null,
      nameKey: null,
      refreshing: false,
      isGlobalQuery: true,
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      elTableHeight: null,
      preTit: '',
      isRole: {}
    };
  },
  components: { Edit, Auth,LabelHeader },
  computed: {
    userInfo: {
      get() {
        return this.$store.state.userInfo;
      },
      set(value) {
        this.$store.commit('setUser', value);
      }
    },
  },
  watch: {
    isGlobalQuery: {
      handler(val){
        this.isGlobalQuery = val;
        if(this.isGlobalQuery) {
          if(this.userInfo) {
            this.nameKey = this.userInfo.name
          } else {
            this.nameKey = ''
          }
          this.teamIdData = ''
        } else {
          this.teamIdData = this.teamId
        }
      }
    }
  },
  destroyed() {
    this.userInfo = {}
  },
  // 页面加载获取数据
  mounted() {
    let route = this.$route;
    if(route.path === '/eap_role_index' && this.userInfo){
      this.nameKey = this.userInfo.name
    } else {
      this.nameKey = ''
    }
    this.tree();
    this.list();
    window.onresize = () => {
      this.changeTableHeight();
    };
    this.changeTableHeight();
  },
  methods: {
    roleAuth(is, id) {
      this.AuthOpen = is;
      this.byId = id;
    },
    roleAdd() {
      this.title = '新增角色';
      this.editParams.id = null;
      this.editParams.tree = this.dataTree;
      this.OpenName = true;
    },
    roleEdit(id) {
      this.title = '编辑角色';
      this.editParams.id = id;
      this.OpenName = true;
    },
    expandAll() {
      this.elTrees = false;
      this.expandAlls = true;
      this.$nextTick(() => {
        this.elTrees = true;
      });
    },
    foldAll() {
      this.elTrees = false;
      this.expandAlls = false;
      this.$nextTick(() => {
        this.elTrees = true;
      });
    },
    // 选择数据
    handleSelectionChange(row) {
      this.arr = row;
    },
    sizeChange(size) {
      this.pagination.size = size;
      this.list();
      this.changeTableHeight();
    },
    currentChange(pageNo) {
      this.pagination.page = pageNo;
      this.list();
    },
    changeTableHeight() {
      let height = document.body.offsetHeight; // 网页可视区域高度
      if (this.pagination.size > 10) {
        this.elTableHeight = height - 324;
      } else {
        this.elTableHeight = null;
      }
    },
    add() {
      this.OpenName2 = true;
    },
    go(value) {
      this.pagination = {
        page: 1,
        size: 10,
        total: 0
      };
      if (value.pid !== '-1') {
        let obj = findInTree(this.dataTree, value.pid, 'id');
        this.preTit = obj.label + ' / ' + value.label + '角色管理';
      } else {
        this.preTit = value.label + '角色管理';
      }
      this.teamId = value.id;
      this.teamIdData = value.id;
      this.editParams.teamName = value.label;
      this.editParams.teamId = value.id;
      this.nameKey = '';
      this.isGlobalQuery = false;
      this.list();
    },
    succ() {
      let that = this;
      that.OpenName = false;
      that.boundRole = false;
      this.OpenName2 = false;
      this.list();
    },
    tree() {
      httpKit.post($api_lims.role.tree).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.length > 0) {
            sessionStorage.setItem('RoleTree', JSON.stringify(res.data.data));
            this.preTit = res.data.data[0].name + '角色管理';
            this.dataTree = res.data.data;
            this.teamId = res.data.data[0].id;
            treeFor(this.dataTree, 'name');
          }
        }
      });
    },
    close() {
      let that = this;
      that.OpenName = false;
      that.AuthOpen = false;
      that.moduleOpen = false;
      that.boundRole = false;
      that.quickModule = false;
      this.OpenName2 = false;
      this.list();
    },
    success() {
      let that = this;
      that.OpenName = false;
      that.boundRole = false;
      this.OpenName2 = false;
      this.list();
      this.tree();
    },
    users() {
      this.AuthOpen = false;
    },
    modules() {
      this.moduleOpen = false;
    },
    list(value) {
      let par = {
        pageNo: value ? value.page : this.pagination.page,
        pageSize: value ? value.size : this.pagination.size,
        pid: this.teamIdData,
        name: this.nameKey
      };
      this.refreshing = true;
      httpKit.post($api_eap.role.search, par).then(res => {
        this.refreshing = false;
        if (res.data.code === '200') {
          this.datas = res.data.data;
          this.pagination.total = +res.data.totalItems;
        } else {
          if (res.data.code === '500') {
            this.datas = [];
          }
        }
      });
    },
    reRun() {
      this.pagination = {
        page: 1,
        size: 10,
        total: 0
      };
      this.list();
    },
    // 多条删除
    removeRole() {
      let selection = this.arr;
      if (selection.length <= 0) {
        this.$message.error('请最少选择一条记录');
      } else if (selection.length > 1) {
        this.$message.error('只能选择一条数据');
      } else {
        this.$confirm('此操作永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let idAryStr = [];
            for (let i = 0; i < selection.length; i++) {
              idAryStr.push(selection[i].id);
            }
            idAryStr = idAryStr.toString();
            httpKit.post($api_eap.role.delete, { ids: idAryStr }).then(res => {
              if (res.data.code === '200') {
                this.$message.success('删除成功');
                this.succ();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message.warning('已取消');
          });
      }
    }
  }
};
</script>
<style scoped lang="less">

  .roleIndex {
    /deep/ .ivu-split-wrapper {
      overflow: hidden;
    }
    .buttons {
      padding-left: 10%;
      margin-bottom: 8px;
      width: 100%;
      display: flex;
      border-bottom: 1px solid #e9e9e9;
    }
    .paginationBox {
      margin-top: -34px;
    }
    .PL20{
      padding-left: 20px;
    }
    .roleSearchForm{
      .el-form-item{
        margin: 5px auto;
        .roleName{
          margin-right: 10px;
        }
        .roleSearchBtn{
          margin-left: 10px;
        }
      }
    }
  }
</style>
